import React, { useEffect, useRef, useState } from "react";
import {
  bootstrapCameraKit,
  createMediaStreamSource,
  Transform2D,
} from "@snap/camera-kit";
import "./SnapCamera.css";
import html2canvas from "html2canvas";
import Header from "../../components/Header";
import { decryptToken } from "../../utils/DecrptyToken";
import InvalidPage from "../../components/InvalidPage";
import Slider from "../../components/Slider";
import { Loader } from "../../components/Loader";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import data from "../../mock/urls.json";
import CameraImage from "../../assets/CameraAndNoBackgroundShare.png";
import ChatbotImage from "../../assets/chatbot.png";
import DonateImage from "../../assets/donation.png";
import audio from "../../assets/camera-click.mp3";
import ProfileImage from "../../assets/profile.png";
import WebView from "../../components/WebView";
import BlinkingBullseyes from "../../components/BlinkingBullseyes";
let mediaStream;

const SnapCamera = ({ groupid, lensid }) => {
  const canvasRef = useRef(null);
  const apiToken = process.env.REACT_APP_SNAP_API_TOKEN;
  const sessionRef = useRef(null);
  const [isUsingToken, setIsUsingToken] = useState(false);

  const [lensGroupId, setLensGroupId] = useState(groupid || null);
  const [lensId, setLensId] = useState(lensid || null);
  const [showInvalid, setShowInvalid] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [filters, setFilters] = useState([]);
  const [lensIndex, setLensIndex] = useState(0);
  const [snapLenses, setSnapLenses] = useState({});
  const [loading, setLoading] = useState(true);
  const [buyNowUrl, setBuyNowUrl] = useState(null);
  const [chatbotUrl, setChatbotUrl] = useState(null);
  const [donateUrl, setDonateUrl] = useState(null);
  const [leftBuyUrl, setLeftBuyUrl] = useState(null);
  const [rigthBuyUrl, setRightBuyUrl] = useState(null);
  const [profileUrl, setProfileUrl] = useState(null);

  const [profileImage, setProfileImage] = useState(null);
  const [customBuyNowImage, setCustomBuyNow] = useState(null);
  const [customHeader, setCustomHeader] = useState("");

  useEffect(() => {
    const init = async () => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      handleResize();

      // const token = propToken || new URLSearchParams(window.location.search).get("lens");
      if (!groupid || !lensid) {
        const token = new URLSearchParams(window.location.search).get("lens");

        if (token) {
          try {
            const decryptedToken = JSON.parse(decryptToken(token));

            console.debug("decryptedToken", decryptedToken);

            setIsUsingToken(true);
            setLensGroupId(decryptedToken.group_id);
            setLensId(decryptedToken.lens_id);
            setCompanyId(decryptedToken.company_id);
            setBuyNowUrl(data[decryptedToken.company_id]["buy_now"]);
            setChatbotUrl(data[decryptedToken.company_id]["chatbot"]);
            setDonateUrl(data[decryptedToken.company_id]["donate"]);
            setLeftBuyUrl(data[decryptedToken.company_id]["left_buy"]);
            setRightBuyUrl(data[decryptedToken.company_id]["right_buy"]);
            setProfileUrl(data[decryptedToken.company_id]["profile"]);

            setCustomBuyNow(data[decryptedToken.company_id]["custom_cart_image"]);
            setCustomHeader(data[decryptedToken.company_id]["custom_title_header"]);
            setProfileImage(
              data[decryptedToken.company_id]["custom_profile_image"]
            );
          }
          catch (err) {
            console.log(err);
            setShowInvalid(true);
            setLoading(false);
            return;
          }
        }
        else {
          setShowInvalid(true);
          setLoading(false);
          return;
        }

      }
    };

    init();
  }, [groupid, lensid]);

  useEffect(() => {
    try {
      if (lensGroupId !== null) {
        const loadLensGroup = async () => {
          const cameraKit = await bootstrapCameraKit({
            apiToken: apiToken.trim(),
          });

          const session = await cameraKit.createSession();
          sessionRef.current = session;

          session.events.addEventListener("error", (event) => {
            if (event.detail.error.name === "LensExecutionError") {
              console.log(
                "The current Lens encountered an error and was removed.",
                event.detail.error
              );
              alert("Error while rendering");
            }
          });

          const canvas = canvasRef.current;
          if (canvas) {
            canvas.replaceWith(session.output.live);
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
          }

          const { lenses } = await cameraKit.lenses.repository.loadLensGroups([
            lensGroupId,
          ]);
          setSnapLenses(lenses);
          const lens = lenses.find((lens) => lens.id === lensId);
          const i = lenses.findIndex((lens) => lens.id === lensId);
          setLensIndex(i);
          setFilters(lenses.map((lens) => lens.iconUrl));
          if (lens === undefined) {
            setShowInvalid(true);
            setLoading(false);
            return;
          }
          session.applyLens(lens);
          await setCameraKitSource(session);
          setLoading(false);
        };

        loadLensGroup();
      }
    } catch (error) {
      console.log(error);
      setShowInvalid(true);
      setLoading(false);
    }
  }, [lensGroupId, showInvalid, loading, lensId, apiToken]);

  const mergeImagesUsingCanvas = async (blob1, blob2) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const img1Src = URL.createObjectURL(blob1);
    const img2Src = URL.createObjectURL(blob2);

    const img1 = new Image();
    img1.src = img1Src;
    await new Promise((resolve) => {
      img1.onload = resolve;
    });

    canvas.width = img1.width;
    canvas.height = img1.height;

    ctx.drawImage(img1, 0, 0, canvas.width, canvas.height);

    const img2 = new Image();
    img2.src = img2Src;
    await new Promise((resolve) => {
      img2.onload = resolve;
    });

    ctx.drawImage(img2, 0, 0, canvas.width, canvas.height);

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        URL.revokeObjectURL(img1Src);
        URL.revokeObjectURL(img2Src);
        resolve(blob);
      }, "image/png");
    });
  };

  const playAudio = () => {
    new Audio(audio).play();
  };

  const handleShare = async () => {
    const elementToCapture = document.getElementById("container");
    const session = sessionRef.current;
    const canvas = session.output.live;

    if (!elementToCapture) {
      console.error("Element not found.");
      return;
    }

    try {
      const screenshotBlob = await new Promise((resolve) => {
        canvas.toBlob(resolve, "image/png");
      });

      const element = document.getElementById("app");
      const canvasOuterFrame = await html2canvas(element, {
        backgroundColor: null,
        allowTaint: true,
        useCORS: true,
      });

      const frameBlob = await new Promise((resolve) => {
        canvasOuterFrame.toBlob(resolve, "image/png");
      });

      const mergedBlob = await mergeImagesUsingCanvas(
        screenshotBlob,
        frameBlob
      );
      const mergedFile = new File([mergedBlob], "screenshot.png", {
        type: "image/png",
      });

      const shareData = { files: [mergedFile] };

      if (navigator.canShare && navigator.canShare({ files: [mergedFile] })) {
        try {
          await navigator.share(shareData);
        } catch (error) {
          console.error("Error sharing:", error);
        }
      } else {
        console.error("Sharing not supported on this device or browser.");
      }
    } catch (error) {
      console.error("Error during screenshot. Falling back:", error);

      try {
        const fallbackScreenshotBlob = await new Promise((resolve) => {
          canvas.toBlob(resolve, "image/png");
        });

        const fallbackScreenshotFile = new File(
          [fallbackScreenshotBlob],
          "screenshot.png",
          {
            type: "image/png",
          }
        );

        const fallbackShareData = { files: [fallbackScreenshotFile] };

        if (
          navigator.canShare &&
          navigator.canShare({ files: [fallbackScreenshotFile] })
        ) {
          await navigator.share(fallbackShareData);
        } else {
          console.error("Fallback sharing not supported.");
        }
      } catch (fallbackError) {
        console.error("Error sharing fallback screenshot:", fallbackError);
      }
    }
  };

  const setCameraKitSource = async (session, deviceId) => {
    if (mediaStream) {
      session.pause();
      mediaStream.getVideoTracks()[0].stop();
    }

    mediaStream = await navigator.mediaDevices.getUserMedia({
      video: { deviceId },
    });

    const source = createMediaStreamSource(mediaStream);
    const width = window.innerWidth;
    const height = window.innerHeight;
    const renderHeight = isMobile ? 540 : 700;
    await session.setSource(source);
    if (!isMobile) {
      await source.setRenderSize(Math.min(480, width - 20), renderHeight);
    } else {
      await source.setRenderSize(width, height);
    }

    source.setTransform(Transform2D.MirrorX);

    session.play();
  };

  useEffect(() => {
    const session = sessionRef.current;
    const lens = snapLenses[lensIndex];
    if (session && lens) {
      session.applyLens(lens);
    }
  }, [lensIndex, snapLenses]);

  return (
    <div id="app">
      {loading ? (
        <Loader />
      ) : showInvalid ? (
        <InvalidPage />
      ) : (
        <div>
          <div>
          </div>
          {leftBuyUrl || rigthBuyUrl ? (
            <div>
              <BlinkingBullseyes
                leftLink={leftBuyUrl}
                rightLink={rigthBuyUrl}
              />
            </div>
          ) : (
            <div></div>
          )}

          {isUsingToken && (
            <div>
              {customBuyNowImage && (
                <div
                  className="buy-now-icon"
                  hidden={!buyNowUrl}
                  onClick={() => buyNowUrl && window.open(buyNowUrl)}
                >
                  <img
                    src={customBuyNowImage}
                    alt="BuyNow"
                    style={{ width: "30px", height: "30px" }}
                  />
                </div>
              )}


              {!customBuyNowImage && (
                <div
                  className="buy-now-icon"
                  onClick={() => buyNowUrl && window.open(buyNowUrl)}
                  hidden={!buyNowUrl}
                >
                  <ShoppingCartIcon sx={{ width: "35px", height: "35px" }} />
                </div>
              )}


              {chatbotUrl && (
                <div
                  className="donate-icon"
                  onClick={() => chatbotUrl && window.open(chatbotUrl)}
                  hidden={!chatbotUrl}
                >
                  <img
                    src={ChatbotImage}
                    alt="Chatbot"
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>
              )}


              <div
                className="donate-icon"
                hidden={!donateUrl}
                onClick={() => donateUrl && window.open(donateUrl)}
              >
                <img
                  src={DonateImage}
                  alt="Donate"
                  style={{ width: "30px", height: "30px" }}
                />
              </div>
              <div
                className="profile-icon"
                hidden={!profileUrl}
                onClick={() => profileUrl && window.open(profileUrl)}
              >
                <img
                  src={profileImage}
                  alt="Profile"
                  style={{ width: "30px", height: "30px" }}
                />
              </div>
            </div>
          )}


          {/* The share icon goes here  */}
          <div className="share-icon" onClick={() => {
            playAudio();
            handleShare();
          }}>
            <img
              src={CameraImage}
              alt="Share"
              style={{ width: "30px", height: "30px" }}
            />
          </div>
          {/* The share icon ends here  */}

          <div className="container" id="container">
            <canvas ref={canvasRef} id="canvas-container"></canvas>
          </div>

          <div id="slider-div">
            <Slider
              filters={filters}
              lensIndex={lensIndex}
              setLensIndex={setLensIndex}
              buyNowUrl={buyNowUrl}
              handleShare={handleShare}
              playCameraSound={playAudio}
              customBuyNowImage={customBuyNowImage}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SnapCamera;
